<template>
  <div>
    <!-- <div v-if="plaintiffs"> -->

    <v-expand-transition v-for="(defendant, index) in defendants" :key="index">
      <v-card
        class="ma-2 mb-3 ml-4"
        shaped
        style="border: 2px solid red"
        color="#E8E8E8"
      >
        <v-row>
          <v-flex>
            <v-card-text
              class="title ml-3"
              align="left"
              @click="viewDefendant(defendant)"
              >{{ defendant.fullName }}</v-card-text
            >
          </v-flex>
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-btn
              class="ma-1"
              text
              small
              rounded
              color="secondary"
              @click="viewDefendant(defendant)"
              >view</v-btn
            >
            <v-btn
              small
              class="ma-1"
              text
              rounded
              color="secondary"
              @click="deleteDefendant(defendant)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-expand-transition>
  </div>
  <!-- <div>HELLO</div> -->
  <!-- </div> -->
</template>

<script>
import firebase from "firebase";
export default {
  props: ["matter", "user"],
  data() {
    return {
      // plaintiffs: this.matter.plaintiffs
      // selectedDefendants: []
    };
  },
  computed: {
    defendants() {
      return this.matter.defendants;
    }
  },
  methods: {
    viewDefendant(defendant) {
      console.log(defendant);
      // let payload = {
      //   partyType: "defendant",
      //   party: defendant
      // };
      this.$store.dispatch("viewDefendant", defendant);
    },
    deleteDefendant(defendant) {
      // let newArray = Array.from(this.matter.plaintiffs);

      // //remove the doc from the array
      // newArray.splice(index, 1);
      // console.log("newArray", newArray);
      // console.log("oldArray", this.matter.plaintiffs);
      firebase
        .firestore()
        .collection("firms")
        .doc(this.user.firmSlug)
        .collection("matters")
        .doc(this.matter.matterSlug)
        .update({
          defendants: firebase.firestore.FieldValue.arrayRemove(defendant)
        })
        .then(() => {
          console.log("success");
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
